import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class TrnDischargeApproveUserListService {
  trnDischargeApproveUserList: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'trn_discharge_approve_user_list/list/?';
  private AddRecord = webapi + 'trn_discharge_approve_user_list/create';
  private EditRecord = webapi + 'trn_discharge_approve_user_list/update';
  private GetRecord = webapi + 'trn_discharge_approve_user_list/byid/';
  private DeleteRecord = webapi + 'trn_discharge_approve_user_list/delete/';
  private ListbyadmissinId = webapi + 'trn_discharge_approve_user_list/dischargeadmissionllist/';
  private userlist = webapi + 'trn_discharge_approve_user_list/dischargestafflist/';
  private adminlist = webapi + 'trn_discharge_approve_user_list/dischargealllist/';

  constructor(
    private http: Http
  ) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllAdmissionIDRecordService(admissionid: any) {
    return this.http.get(this.ListbyadmissinId + admissionid)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordadminService(status: any): Promise<any> {
    return this.http.get(this.adminlist + status)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecorduserService(staffid: any, status: any): Promise<any> {
    return this.http.get(this.userlist + status + '/' + staffid)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    // console.log(JSON.stringify(model));
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/trn-discharge-approve-user-list/trn-discharge-approve-user-list.service.ts